<section class="laft-form--container">
  <div class="laft-form--header" *ngIf="currentStep === 1">
    <button class="laft-form--btn-close" (click)="save(true)">Guardar y salir</button>
  </div>
  <div *ngIf="currentStep > 1" class="laft-form--header laft-form--header-actions">
    <button class="laft-form--btn-back" (click)="onPreviousStep()">
      <lib-icon icon="arrow_left" size="m" color="gradient-dark-blue"></lib-icon> Atrás
    </button>
    <button class="laft-form--btn-close" (click)="save(true)">Guardar y salir</button>
  </div>
  <app-laft-stepper class="laft-form--stepper" (submit)="onStepperSubmit($event)">
    <!-- Step 1 -->
    <app-laft-step>
      <app-laft-company-data-form
        class="full"
        stepContent
        [userData]="data?.user"
        [initData]="initFormData"
        (nextStep)="onFormNextStep(2, $event)"
        (formChangesEvent)="setFormData($event, 'step1Data')"
      ></app-laft-company-data-form>
    </app-laft-step>
    <!-- Step 2 -->
    <app-laft-step>
      <app-laft-company-beneficiary-form
        (formChangesEvent)="setFormData($event, 'step2Data')"
        (nextStep)="onFormNextStep(3, $event)"
        stepContent
        class="full"
        [userData]="data?.user"
        [initData]="initFormData"
      ></app-laft-company-beneficiary-form>
    </app-laft-step>
    <!-- Step 3 -->
    <app-laft-step>
      <app-laft-company-pep-form
        (formChangesEvent)="setFormData($event, 'step3Data')"
        (nextStep)="onFormNextStep(4, $event)"
        stepContent
        class="full"
        [initData]="initFormData"
        [firstLegalRepresentative]="firstLegalRepresentativeName"
        [legalRepresentativesList]="legalRepresentativesList"
        [isPendingPepFlow]="isPendingPepFlow"
        [airtableRepresentativesList]="airtableRepresentativesList"
      ></app-laft-company-pep-form>
    </app-laft-step>
    <!-- Step 4 -->
    <app-laft-step>
      <div class="full" stepContent>
        <app-laft-legal-investigation-form
          class="full"
          stepContent
          [initData]="initFormData"
          [isClient]="data?.user?.role === Roles.CLIENT"
          [isSaving]="isSavingStep"
          (nextStep)="onStep4Submit($event)"
          (formChangesEvent)="setFormData($event, 'step4Data')"
        ></app-laft-legal-investigation-form>
      </div>
    </app-laft-step>
  </app-laft-stepper>
</section>
